import { AddSusunanKeluargaPayload } from "../../../../models/SusunanKeluarga";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allSusunanKeluargaKey } from "../../queries/SusunanKeluarga/useFetchAllSusunanKeluarga";
import { allSusunanKeluargaOTKey } from "../../queries/SusunanKeluarga/useFetchAllSusunanKeluargaOT";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function addSusunanKeluarga(data: AddSusunanKeluargaPayload) {
  const res = await ApiClient.post(`/AddKeluarga`, data);
  return res.data;
}

export const useAddSusunanKeluarga = mutationWrapper(addSusunanKeluarga, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allSusunanKeluargaOTKey);
    getQueryClient().invalidateQueries(allSusunanKeluargaKey);
    getQueryClient().invalidateQueries(checkProfileKey);
  },
});
